export default "__VITE_ASSET__CVBC2hvY__"